module.exports = __webpack_public_path__ + "img/avatarSelected.99ec5bfc.png";